import axios, { CancelToken } from 'axios';

export const cancelationSubscribe = (signal: AbortSignal): CancelToken => {
  const source = axios.CancelToken.source();

  signal.addEventListener('abort', () => source.cancel());

  return source.token;
};
